/* M'OUD v16 «Maison Ruhe» (24.10.2026): Filmquelle nach Bildschirm, Abdunkeln beim Scrollen, ruhiges Einblenden. */
(function(){
  var d=document,w=window,root=d.querySelector('.m16');
  if(!root)return;
  var portrait=function(){return w.matchMedia('(max-width:767px)').matches};
  var reduce=w.matchMedia('(prefers-reduced-motion:reduce)').matches;
  // Filme: Hoch- oder Querformat laden
  d.querySelectorAll('video[data-src-l]').forEach(function(v){
    var src=portrait()?(v.dataset.srcP||v.dataset.srcL):v.dataset.srcL;
    if(portrait()&&v.dataset.posterP)v.poster=v.dataset.posterP;
    if(!src||src.indexOf('VIDEO_')===0)return;
    if(reduce){return}
    v.src=src;v.muted=true;
    var p=v.play();if(p&&p.catch)p.catch(function(){});
  });
  requestAnimationFrame(function(){setTimeout(function(){root.classList.add('go')},60)});
  // Banner: beim Scrollen weich abdunkeln und unscharf werden
  var ban=d.querySelector('.m16-ban');
  if(ban&&!reduce){
    var tick=false;
    var upd=function(){tick=false;var vh=w.innerHeight||800;var p=Math.min(1,Math.max(0,(w.scrollY)/(vh*.85)));ban.style.setProperty('--m16p',p.toFixed(3))};
    w.addEventListener('scroll',function(){if(!tick){tick=true;requestAnimationFrame(upd)}},{passive:true});upd();
  }
  // Einblenden
  var els=d.querySelectorAll('.m16-pr,.m16 .rv16');
  if('IntersectionObserver' in w){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{threshold:.18});
    els.forEach(function(e){io.observe(e)});
  }else{els.forEach(function(e){e.classList.add('in')})}
  // Unternavigation markieren
  var sub=d.querySelectorAll('.m16-sub a');
  if(sub.length&&'IntersectionObserver' in w){
    var io2=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){sub.forEach(function(a){a.classList.toggle('on',a.getAttribute('href')==='#'+e.target.id)})}})},{rootMargin:'-45% 0px -50% 0px'});
    d.querySelectorAll('.m16-pr[id]').forEach(function(s){io2.observe(s)});
  }
  // Weiche Sprünge
  d.addEventListener('click',function(e){var a=e.target.closest&&e.target.closest('[data-m16go]');if(!a)return;var t=d.querySelector(a.getAttribute('data-m16go'));if(!t)return;e.preventDefault();var hd=parseInt(getComputedStyle(d.body).getPropertyValue('--m16-hd'))||64;var y=t.getBoundingClientRect().top+w.scrollY-(t.classList.contains('m16-three')?0:hd+48);w.scrollTo({top:y,behavior:reduce?'auto':'smooth'})});
})();
/* v17: leere Stimmen (ohne Satz) ausblenden, auch wenn sie später nachgeladen werden */
(function(){var d=document;function clean(){d.querySelectorAll('.rev .r').forEach(function(r){var q=r.querySelector('.q');if(!q||!q.textContent.replace(/[«»“”"\s]/g,'')){r.style.display='none'}})}
clean();if('MutationObserver' in window){var t;new MutationObserver(function(){clearTimeout(t);t=setTimeout(clean,60)}).observe(d.body,{childList:true,subtree:true})}})();
/* v19: Stimmen-Block ohne Stimmen ausblenden (erscheint, sobald Stimmen geladen sind) */
(function(){var d=document;function chk(){d.querySelectorAll('[data-sec="pdp-voices"]').forEach(function(s){var n=[].filter.call(s.querySelectorAll('.r'),function(r){return r.style.display!=='none'}).length;s.style.display=n?'':'none'})}
chk();if('MutationObserver' in window){var t;new MutationObserver(function(){clearTimeout(t);t=setTimeout(chk,120)}).observe(d.body,{childList:true,subtree:true})}})();
